import {
  GO_TO_APPLIANCE_STEP,
  SET_APPLIANCE_FORM_PRISTINE,
  SET_APPLIANCE_FORM_VALID,
  RESET_APPLIANCE_FORM_DATA
} from '#action/types';

const defaultState = {
  step: 0,
  pristine: {},
  valid: {}
};

export default (state = defaultState, action) => {
  switch (action.type) {
    case GO_TO_APPLIANCE_STEP:
      return { ...state, step: action.payload };
    case SET_APPLIANCE_FORM_PRISTINE:
      return {
        ...state,
        pristine: {
          ...state.pristine,
          [action.payload.form]: action.payload.value
        }
      };
    case SET_APPLIANCE_FORM_VALID:
      return {
        ...state,
        valid: {
          ...state.pristine,
          [action.payload.form]: action.payload.value
        }
      };
    case RESET_APPLIANCE_FORM_DATA:
      return defaultState;
    default:
      return state;
  }
};
